import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractCommand from './abstractCommand';

/**
 * Resize item command
 *
 * @class ResizeItemCommand
 * @extends AbstractCommand
 */
export default class ResizeConnectorItemCommand extends AbstractCommand {
    constructor(item, line) {
        super();
        this.item = item;

        this.initialLine = this.item.get('line');
        this.line = line !== undefined ? line : this.initialLine;
    }

    /**
     * Is this a valid command?
     *
     * @return {boolean}
     */
    isValid() {
        return true;
    }

    setLine(line) {
        this.line = line;
    }

    /**
     * Execute command
     */
    execute() {
        if (!this.isValid()) return;

        this.item.set('line', this.line);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        if (!this.isValid()) return;

        this.item.set('line', this.initialLine);
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return 'Resize Connector';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.ResizeConnectorItemCommand = ResizeConnectorItemCommand;
